module.exports = __webpack_public_path__ + "static/media/manager_graphic17.917e3900.png";